import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import Navbar from '../home/components/Navbar';
import FooterSection from '../home/components/FooterSection';
import SEOHead from '../../components/feature/SEOHead';
import { SITE_URL } from '../../utils/seo';

const posts = [
  {
    id: 1,
    slug: 'storage-yenileme-maliyeti-2026',
    title: '2026\'da Depolama Yenilemenin Artan Maliyeti',
    excerpt: 'DRAM fiyatları yıllık bazda %171 arttı. Özel kurumsal flash stok dışı. Lisanslama değişiklikleri acıyı daha da artırıyor. İşte 2026\'da depolama yenilemenin neden her zamankinden pahalı olduğu.',
    category: 'Depolama',
    date: '16 Mart 2026',
    author: 'George Crump',
    image: 'https://www.verge.io/wp-content/uploads/2026/03/Banner-The-Even-Higher-Cost-of-a-Storage-Refresh-in-2026-1024x459.png',
    featured: true,
  },
  {
    id: 2,
    slug: 'ram-tuketimi-azaltma',
    title: 'Hipervizör RAM Tüketimini Nasıl Azaltır',
    excerpt: 'Bellek ve Flash Süperdöngüsü,&nbsp; alternatifleri sunması gereken çıtayı yükseltti. Doğru hipervizör yalnızca daha az lisans ücreti almaz — host başına RAM tüketimini azaltmalı, daha az sunucu gerektirmeli ve flash depolama maliyetlerini düşürmelidir.',
    category: 'Özel Bulut',
    date: '9 Mart 2026',
    author: 'George Crump',
    image: 'https://www.verge.io/wp-content/uploads/2026/03/VergeIO-Ram-supercycle-blog1-1024x502.png',
    featured: false,
  },
  {
    id: 3,
    slug: 'vm-yogunluk-patlama-yaricapi',
    title: 'VM Yoğunluğunun Gizli Riski: Patlama Yarıçapı',
    excerpt: 'VM yoğunluğunu artırmak donanım maliyetlerini düşürür ve veri merkezi ayak izini küçültür. Ancak sunucu başarısız olduğunda daha büyük bir patlama yarıçapıyla karşılaşırsınız. VergeOS bu sorunu katmanlı koruma ile çözer.',
    category: 'Veri Koruma',
    date: '2 Mart 2026',
    author: 'George Crump',
    image: 'https://www.verge.io/wp-content/uploads/2026/03/VergeIO-26.1-Blog-Banner-2-1024x683.png',
    featured: false,
  },
  {
    id: 4,
    slug: 'felaket-kurtarma-roi',
    title: 'Felaket Kurtarmadan ROI Elde Etmek',
    excerpt: 'Kuruluşlar, DR altyapısını aktif kullanıma sokarak felaket kurtarmadan ROI elde edebilir. VergeOS, boşta bekleyen kapasiteyi test, yük yönetimi ve iş yükü kurtarma için bir varlığa dönüştürür.',
    category: 'Veri Koruma',
    date: '23 Şubat 2026',
    author: 'George Crump',
    image: 'https://www.verge.io/wp-content/uploads/2026/02/VergeIO-26-1-Blog-1-Banner-1-1024x378.png',
    featured: false,
  },
  {
    id: 5,
    slug: 'kolay-vmware-alternatifi',
    title: 'Kurulumu ve Kullanımı Kolay En iyi Alternatif',
    excerpt: 'VergeOS, tek bir oturumda kurulabilen ve tek bir arayüz üzerinden yönetilen bir alternatiftir. Bağımsız bir incelemeyi izleyin, uygulamalı laboratuvarlara katılın veya teknik genel bakış planlayın.',
    category: 'Migration',
    date: '18 Şubat 2026',
    author: 'George Crump',
    image: 'https://www.verge.io/wp-content/uploads/2026/02/Featured-Image-for-Getting-Started-with-VergeOS-1024x683.png',
    featured: false,
  },
  {
    id: 6,
    slug: 'vmware-alternatifleri-kriterler',
    title: 'Sanallaştırma Platformu Alternatifleri İçin Gözden Kaçırılan Kriterler',
    excerpt: 'DCIG, 19 sanallaştırma platformu alternatifini 425\'ten fazla özellik üzerinden değerlendirdi. Ancak özellik karşılaştırmaları en önemli olanı gözden kaçırıyor: satıcı taahhüdü, destek yetenekleri ve mimari verimlilik.',
    category: 'Migration',
    date: '14 Şubat 2026',
    author: 'George Crump',
    image: 'https://www.verge.io/wp-content/uploads/2026/02/VergeIO-DCIG-Blog-Banner-Smaller-1024x683.png',
    featured: false,
  },
  {
    id: 7,
    slug: 'vmwareden-ozel-buluta',
    title: "Özel Buluta Geçiş",
    excerpt: "Özel buluta geçiş için geleneksel yöntem hipervizörleri değiştirmektir. Daha iyi yol ise altyapıyı entegre platformlarda birleştirmektir. Dört veya daha fazla sunucu çalıştıran kuruluşlar birleşik yönetim ve verimlilik avantajları elde eder.",
    category: 'Özel Bulut',
    date: '2 Şubat 2026',
    author: 'George Crump',
    image: 'https://www.verge.io/wp-content/uploads/2026/02/vmware-to-private-cloud-1024x683.webp',
    featured: false,
  },
  {
    id: 8,
    slug: 'ozel-bulut-os-nedir',
    title: 'Özel Bulut İşletim Sistemi Nedir?',
    excerpt: 'Çoğu alternatif hipervizör değişimine odaklanır. Bu yaklaşım pahalı depolama dizilerini, özel ağları ve karmaşık işlemleri korur. Özel Bulut OS ise tüm veri merkezini tek bir sistem olarak sanallaştırır.',
    category: 'Özel Bulut',
    date: '19 Ocak 2026',
    author: 'George Crump',
    image: 'https://www.verge.io/wp-content/uploads/2026/01/private-cloud-blog-banner-1024x683.webp',
    featured: false,
  },
  {
    id: 9,
    slug: 'vxrail-alternatifleri',
    title: "VxRail Alternatifleri ve Migration",
    excerpt: "Dell, VxRail müşterilerini yeni sunucular ve harici depolama dizileri gerektirerek altyapı karmaşıklığını yeniden ortaya çıkaran Dell Private Cloud'a yönlendiriyor. VergeOS mevcut VxRail donanımında çalışır.",
    category: 'Özel Bulut',
    date: '7 Ocak 2026',
    author: 'George Crump',
    image: 'https://www.verge.io/wp-content/uploads/2026/01/VxRail_Alternatives_VMware_Exit-1024x683.webp',
    featured: false,
  },
  {
    id: 10,
    slug: 'yerinde-vmware-cikisi',
    title: "Onpremise Migration",
    excerpt: "VergeOS, platform değişimi donanım yenilemesinden ayırır. Kuruluşlar mevcut sunucularını korur, hazır SSD'ler ekler ve iş yüklerini kademeli olarak taşır. Lisanslama maliyetleri %65 düşer.",
    category: 'Migration',
    date: '23 Aralık 2025',
    author: 'George Crump',
    image: 'https://www.verge.io/wp-content/uploads/2025/12/In-Plac-Blog-Banner-1024x683.png',
    featured: false,
  },
];

const categories = ['Tümü', 'Depolama', 'Özel Bulut', 'Veri Koruma', 'Migration'];

const blogJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Blog',
  name: 'VergeIO Blog',
  url: `${SITE_URL}/blog`,
  description: 'VergeOS uzmanlarından altyapı modernizasyonu, VMware migration ve özel bulut teknolojileri hakkında güncel analizler.',
  publisher: {
    '@type': 'Organization',
    name: 'VergeIO',
    url: SITE_URL,
  },
};

export default function BlogPage() {
  const navigate = useNavigate();
  const [activeCategory, setActiveCategory] = useState('Tümü');
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const featured = posts[0];
  const filtered = activeCategory === 'Tümü'
    ? posts.slice(1)
    : posts.slice(1).filter(p => p.category === activeCategory);

  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;
    try {
      const body = new URLSearchParams();
      body.append('email', email);
      await fetch('https://readdy.ai/api/form/d6t6qdoq778icnc8ujfg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      setSubscribed(true);
    } catch {
      setSubscribed(true);
    }
  };

  return (
    <div className="min-h-screen bg-white font-sans">
      <SEOHead
        title="Blog | VergeOS Altyapı ve VMware Migration Analizleri"
        description="VergeOS uzmanlarından altyapı modernizasyonu, VMware migration, özel bulut ve depolama teknolojileri hakkında güncel analizler ve rehberler."
        keywords="altyapı blog, VMware migration, özel bulut, depolama maliyeti, VergeOS blog, sanallaştırma analizi"
        canonicalPath="/blog"
        jsonLd={blogJsonLd}
      />
      <Navbar />

      {/* Hero */}
      <section className="bg-[#1a1a2e] py-16">
        <div className="max-w-[1200px] mx-auto px-6 text-center">
          <span className="inline-block bg-[#e8600a]/20 text-[#e8600a] text-xs font-semibold px-3 py-1 rounded-full mb-4 uppercase tracking-wider">Blog</span>
          <h1 className="text-4xl font-bold text-white mb-4">Sektör Uzmanlarından İçgörüler</h1>
          <p className="text-gray-300 text-lg max-w-xl mx-auto">Altyapı modernizasyonu, migration ve özel bulut teknolojileri hakkında güncel analizler.</p>
        </div>
      </section>

      {/* Featured */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-[1200px] mx-auto px-6">
          <h2 className="text-sm font-semibold text-[#e8600a] uppercase tracking-widest mb-6">Öne Çıkan Yazı</h2>
          <div
            className="bg-white rounded-xl overflow-hidden border border-gray-100 cursor-pointer hover:border-[#e8600a]/30 transition-all"
            onClick={() => navigate(`/blog/${featured.slug}`)}
          >
            <div className="grid grid-cols-2 gap-0">
              <div className="p-10 flex flex-col justify-center">
                <span className="inline-block bg-[#e8600a]/10 text-[#e8600a] text-xs font-semibold px-3 py-1 rounded-full mb-4 w-fit">{featured.category}</span>
                <h2 className="text-2xl font-bold text-[#1a1a2e] mb-4 leading-tight hover:text-[#e8600a] transition-colors">{featured.title}</h2>
                <p className="text-gray-600 text-sm leading-relaxed mb-6">{featured.excerpt}</p>
                <div className="flex items-center gap-4">
                  <div className="flex items-center gap-2 text-xs text-gray-500">
                    <span className="w-5 h-5 flex items-center justify-center"><i className="ri-calendar-line"></i></span>
                    {featured.date}
                  </div>
                </div>
              </div>
              <div className="w-full h-72 overflow-hidden">
                <img src={featured.image} alt={featured.title} className="w-full h-full object-cover object-top" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Category Filter */}
      <section className="py-4 border-b border-gray-100 sticky top-16 bg-white z-10">
        <div className="max-w-[1200px] mx-auto px-6 flex gap-2 flex-wrap">
          {categories.map(cat => (
            <button
              key={cat}
              onClick={() => setActiveCategory(cat)}
              className={`px-4 py-1.5 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                activeCategory === cat
                  ? 'bg-[#e8600a] text-white'
                  : 'bg-gray-100 text-gray-600 hover:bg-orange-50 hover:text-[#e8600a]'
              }`}
            >
              {cat}
            </button>
          ))}
        </div>
      </section>

      {/* Posts Grid */}
      <section className="py-16">
        <div className="max-w-[1200px] mx-auto px-6">
          <h2 className="text-sm font-semibold text-[#e8600a] uppercase tracking-widest mb-8">Tüm Yazılar</h2>
          <div className="grid grid-cols-3 gap-6">
            {filtered.map(post => (
              <article
                key={post.id}
                className="bg-white rounded-xl border border-gray-100 overflow-hidden hover:border-[#e8600a]/30 transition-all cursor-pointer group"
                onClick={() => navigate(`/blog/${post.slug}`)}
              >
                <div className="p-5">
                  <span className="inline-block bg-[#e8600a]/10 text-[#e8600a] text-xs font-semibold px-2 py-0.5 rounded-full mb-3">{post.category}</span>
                  <h3 className="text-base font-bold text-[#1a1a2e] mb-2 leading-tight group-hover:text-[#e8600a] transition-colors line-clamp-2">{post.title}</h3>
                  <p className="text-gray-500 text-xs leading-relaxed mb-4 line-clamp-3">{post.excerpt}</p>
                  <div className="flex items-center justify-between text-xs text-gray-400">
                    <span>{post.date}</span>
                    <span className="flex items-center gap-1 text-[#e8600a] font-medium">
                      Devamını oku <i className="ri-arrow-right-line"></i>
                    </span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <FooterSection />
    </div>
  );
}
